import React, { FunctionComponent, useCallback, useEffect } from 'react';
import { Table, Typography } from 'antd';
import { useStore } from 'effector-react';
import users, { getList } from '@stores/users';
import { ColumnsType, TablePaginationConfig } from 'antd/lib/table';
import IUser from '@interfaces/IUser';
import useTranslate from '@hooks/useTranslate';
import componentContent from './SearchHeaderTable.content.json';
import css from './SearchHeaderTable.module.less';
import Avatar from '@components/Avatar';
import { Link } from 'react-router-dom';
import { getPath } from '@helpers/navigation';
import useScrollTopPage from '@hooks/useScrollTopPage';

interface SearchHeaderTableProps {}

const SearchHeaderTable: FunctionComponent<SearchHeaderTableProps> = () => {
  const { list, preloaders, pagination } = useStore(users);
  const content = useTranslate(componentContent);

  const onChange = useCallback((pagination: TablePaginationConfig, sorter: any) => {
    getList({
      pagination: {
        ...pagination,
        pageSize: 10,
      },
      sorter,
    });
  }, []);

  useScrollTopPage(pagination);

  const columns: ColumnsType<IUser> = [
    {
      dataIndex: 'photo',
      width: 48,
      title: '',
      className: css.avatarCell,
      render: (key: string, user: IUser) => <Avatar user={user} />,
    },
    {
      dataIndex: 'nickname',
      key: 'nickname',
      title: content.nickname,
      render: (nickname: string, user: IUser) => (
        <Link
          to={getPath('userDetail', { userId: user.id })}
          className='clickable'
        >
          {nickname}
        </Link>
      ),
    },
    {
      dataIndex: 'email',
      title: 'Email',
      render: (email: string) => email && <Typography.Text copyable>{email}</Typography.Text>,
    },
  ];

  return (
    <div>
      <Table
        onChange={onChange}
        dataSource={list}
        columns={columns}
        loading={!!preloaders.getList}
        rowKey='id'
        pagination={false}
      />
    </div>
  );
};

export default SearchHeaderTable;
